<template>
    <v-simple-table>
        <template v-slot:default>
            <tbody>
                <tr>
                    <td><strong>Brand Name</strong></td>
                    <td>{{ itemHeader.brandName }}</td>
                </tr>
                <tr>
                    <td><strong>Invoice Number</strong></td>
                    <td>{{ itemHeader.invoiceNumber }}</td>
                </tr>
                <tr>
                    <td><strong>Invoice Date</strong></td>
                    <td>{{ itemHeader.invoiceDate }}</td>
                </tr>
                <tr>
                    <td><strong>PO Number</strong></td>
                    <td>{{ itemHeader.poNumber }}</td>
                </tr>
                <tr>
                    <td><strong>PO Date</strong></td>
                    <td>{{ itemHeader.poDate }}</td>
                </tr>
                <tr>
                    <td><strong>Carrier Name</strong></td>
                    <td>{{ itemHeader.carrierName }}</td>
                </tr>
                <tr>
                    <td><strong>Ship date</strong></td>
                    <td>{{ itemHeader.shipDate }}</td>
                </tr>
                <tr>
                    <td><strong>Due Date</strong></td>
                    <td>{{ itemHeader.dueDate }}</td>
                </tr>
                <tr>
                    <td><strong>Terms</strong></td>
                    <td>{{ itemHeader.terms }}</td>
                </tr>
                <tr>
                    <td><strong>Freight Charge</strong></td>
                    <td>{{itemHeader.freightCharge ? itemHeader.freightCharge : '0'}}</td>
                </tr>
                <tr>
                    <td><strong>Invoice Discount</strong></td>
                    <td>{{itemHeader.invoiceDiscount ? itemHeader.invoiceDiscount : '0' }}</td>
                </tr>
                <tr>
                    <td><strong>Total Cost</strong></td>
                    <td>{{ itemHeader.totalCost ? itemHeader.totalCost : '0' }}</td>
                </tr>
            </tbody>
        </template>
     </v-simple-table>
</template>

<script>
import { getters } from '@/store/store'; 
export default {
    computed: {
        ...getters,//getParseResults
        itemHeader(){
            if(this.getParseResults.invoiceInformation){
                return this.getParseResults.invoiceInformation
            }else{
                return {}
            }
        }
    }
}
</script>

